'use strict';
/**
 * Utilities that come in useful across the myStrength app.
 * These are the kinds of things you might expect to find in Angular core, but aren't there.
 * Many of these are taken from the web.
 */

angular.module('msUtility', ['angular-click-outside']);